/* unplugin-vue-components disabled */import script from "./Query.vue?vue&type=script&setup=true&lang=js"
export * from "./Query.vue?vue&type=script&setup=true&lang=js"

import "./Query.vue?vue&type=style&index=0&id=940953a4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-940953a4"]])

export default __exports__